import React from 'react';
import firstImage from "../assets/firstImage.png";
import secondImage from "../assets/secondImage.png";

function Services() {
  const boxWidth = "w-full";
  const boxHeight = "h-full";

  return (
    <section className='bg-[#7F7E75]'>
      <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20 bg-[#7F7E75]">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <div className="flex items-center rounded-md px-3 py-1">
            <p className="text-sm uppercase mb-12">Services</p>
          </div>
          <h2 className="text-3xl font-regular md:text-5xl uppercase mb-20">
            Tailored <span className='italic text-black bg-[#CFF098]'>Digital Strategies</span> for Women-Led Businesses.
          </h2>
        </div>
        <ul className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 md:gap-4">
          <li className={`border-black border-[1px] bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center">
              <img src={firstImage} alt='Consultant meeting her client on the couch with coffee mugs in their hands - Her Growth Co' className='w-24 md:w-32'/>
            </div>
            <p className="mb-3 text-2xl md:text-3xl font-semibold text-black text-center uppercase">
              Custom <br/><span className='italic'> Website </span> <br/>Design
            </p>
            <p className=" text-black text-center text-thin w-full md:w-[350px] text-lg md:text-xl mb-8 md:mb-10 font-light">
              Create a professional and engaging online presence that reflects your brand and attracts your target audience. We connect you with skilled <span className='italic'>web designers</span> to bring your vision to life. <br/> <br/>
              We build user-friendly, responsive websites designed for optimal performance. If you want to <span className='italic'>hire a website builder</span> for a seamless process, we can assist.
            </p>
            <a href='/webdesign'>
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">VIEW OUR WEBSITE DESIGN PORTFOLIO →</button>
            </a>
          </li>
          <li className={`border-black border-[1px] bg-white p-8 md:p-10 flex flex-col items-center justify-between ${boxWidth} ${boxHeight}`}>
            <div className="flex items-center justify-center mb-6 md:mb-8">
              <img src={secondImage} alt='Team of people working together' className='w-24 md:w-32'/>
            </div>
            <p className="text-2xl md:text-3xl font-semibold text-black text-center mb-6 md:mb-8 uppercase">
              Strategic <br/> <span className='italic'> SEO & </span><br/> Local Visibility
            </p>
            <p className=" text-black text-center w-full md:w-[350px] text-lg md:text-xl mb-8 md:mb-10 font-light">
              Improve your search rankings and attract local clients with targeted SEO strategies. Find the right <span className='italic'>web designer for hire</span> to optimize your online presence. <br/> <br/>
              We optimize your website for relevant keywords and enhance your local presence. 
            </p>
            <a href='/seopage'>
              <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black">EXPLORE OUR SEO SERVICES →</button>
            </a>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default Services;